import { Meta } from "@/shared/components";
import { Refunds } from "@/admin/features/refunds";

export function RefundsPage() {
  return (
    <>
      <Meta title="Возвраты" />
      <Refunds />
    </>
  );
}
